export class EvaluateComparabilityValidationErrorResponse {
  comparabilityEvaluation: any;
}
